import { html, LitElement } from "lit-element";
class ChatBotContentEntrance extends LitElement {
    constructor() {
        super(...arguments);
        this.text = "";
    }
    static get properties() {
        return {
            text: { type: String },
        };
    }
    createRenderRoot() {
        return this;
    }
    render() {
        return html `<div class="flex justify-around mv4">
      <span class="jh-dim-green jh-font-small">${this.text}</span>
    </div>`;
    }
}
customElements.define("jh-chat-bot-content-entrance", ChatBotContentEntrance);
//# sourceMappingURL=chatBotContentEntrance.js.map